import moment from "moment";

import { ONLINE_MOMENT, ONLINE_SALE_DURATION } from "../../thor.const";
import { DatepickerRange } from "../../typings/online";
import { thor } from "../../typings/thor";
import { DateService } from "./date.service";

enum TZ {
    EuropeParis = "Europe/Paris"
}

class OnlineDateService extends DateService {
    /**
     * Get default end date from start date: add 7 days
     * @param {startAtDate} online sale start_at date
     * @returns {Date}
     */
    public getEndDate(startAtDate: Date | string): Date {
        if (!startAtDate) {
            return null;
        }
        startAtDate = this.setOnlineStartHour(startAtDate);
        return moment(startAtDate).add(ONLINE_SALE_DURATION, "days").toDate();
    }

    public getDatepickerRange(startDate: Date, endDate: Date): DatepickerRange {
        const range = { start_at: { min: null, max: null }, end_at: { min: null, max: null }};
        const nowDate = moment().toDate();
        const todayStartDate = this.setOnlineStartHour(nowDate);

        startDate = this.setOnlineStartHour(startDate);
        endDate = this.setOnlineStartHour(endDate);

        // after 8 o'clock, datepicker minDate is tomorrow
        range.start_at.min = nowDate > todayStartDate ? moment(angular.copy(nowDate)).add(1, "days").toDate() : nowDate;

        range.start_at.max = endDate ? moment(angular.copy(endDate)).subtract(1, "days").toDate() : null;
        range.end_at.min = startDate ? moment(angular.copy(startDate)).add(1, "days").toDate() : null;

        range.end_at.max = moment().add(1, "year").endOf("year").toDate();

        return range;
    }

    /**
     * eval sale current date status comparing start and end dates with now
     * warn: this method does not take sale.status into account, but dates only
     * @param {sale} online sale
     * @returns {Object}
     */
    public getSaleStatus(sale: thor.SaleGet): {
        saleScheduled: boolean;
        saleStarted: boolean;
        salePast: boolean;
    } {
        const status = { saleScheduled: false, saleStarted: false, salePast: false };
        const { start_at, datetime } = sale || {};

        if (!start_at || !datetime) {
            return status;
        }
        const nowDate = moment().toDate();
        const startDate = moment(start_at).toDate();
        const endDate = moment(datetime).toDate();

        status.saleScheduled = startDate > nowDate;
        status.saleStarted = startDate <= nowDate && endDate >= nowDate;
        status.salePast = endDate < nowDate;

        return status;
    }

    /**
     * eval start and end dates to check if diff exceeds Online 7 days interval
     * @param {Date} online sale date
     * @returns {boolean}
     */
    public isEndDateGreaterThan7Days(fromDate: Date | string, toDate: Date | string): boolean {
        return moment(toDate).diff(moment(fromDate), "days") > ONLINE_SALE_DURATION;
    }

    /**
     * Set Date to online start/end sale hour (8PM)
     * @param {Date} online sale date
     * @returns {Date}
     */
    private setOnlineStartHour(date: Date | string): Date {
        return date ?
            moment(date)
                .set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
                .tz(TZ.EuropeParis)
                .set(ONLINE_MOMENT)
                .toDate() :
            null;
    }
}

angular
    .module("thor.core.dates.online-date.service", [])
    .service("onlineDateService", OnlineDateService);
